var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CommonDrop',{attrs:{"url":"/trade/company/account/list","autoDefault":false,"filterable":true,"remote":true,"size":_vm.size,"clearable":_vm.clearable,"label-name":"accountName","remoteSearchKey":"name"},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }